import EventDispatcher from '../../../../../shared/lib/html5-software-library/src/ranj/util/EventDispatcher';

export default class PuzzleModel extends EventDispatcher {

    constructor(location, allowFail, successFeedback, sequences, rules, timings, timer, sequenceIndex) {
        super();
        this.location = location;
        this.allowFail = allowFail;
        this.successFeedback = successFeedback;
        this.timings = timings;
        this._sequences = sequences;
        this._rules = rules;
        this._sequenceIndex = sequenceIndex;
        this.timer = timer;
        this.reset();
    }

    hasNextSequence() {
        return this._sequenceIndex + 1 < this._sequences.length;
    }

    get sequenceIndex() {
        return this._sequenceIndex;
    }

    get sequence() {
        return this._sequences[this._sequenceIndex];
    }

    get ruleId() {
        return this._rules.id[this._sequenceIndex];
    }

    get correctInput() {
        return this._requiredInput;
    }

    pickSpot(spot) {
        this._pickedSpots.push(spot);
    }

    unpickSpot(spot) {
        this._pickedSpots.remove(spot);
    }

    get sampleFishVariation() {
        var ruleIdLastChar = this.ruleId.slice(this.ruleId.length - 1);
        if ("ABCDEF".includes(ruleIdLastChar)) {
            return { amount: 1, pattern: ruleIdLastChar };
        } else {
            return null;
        }
    }

    get pickedSpots() {
        return this._pickedSpots;
    }

    get lastPickedSpot() {
        if (this._pickedSpots.length < 1) { return null };

        return this._pickedSpots[this._pickedSpots.length - 1];
    }

    reset() {
        this._pickedSpots = [];
        this._requiredInput = this._rules.correctInput[this._sequenceIndex];
    }


    validate() {
        //Just compare picked with required
        const picked = this._pickedSpots.map(spot => spot.id);
        const required = this._requiredInput.slice();//duplicate because we change the array
        //  Sort both lists in the same way, if order is not important
        if (!this._rules.correctOrderRequired) {
            picked.sort((s1, s2) => s1 - s2);
            required.sort((s1, s2) => s1 - s2);
        }
        return picked.join(",") == required.join(",");
    }

}